import type { ComponentType, PropsWithChildren } from 'react';
import type React from 'react';

import type { ErrorStateDetails } from '#src/app/shared/utils/async';
import { isError, isLoaded } from '#src/app/shared/utils/async';

import type { TemplateCombinedState, TemplatePrefetchedContext } from './hook';
import { usePageContext } from './hook';
import { TemplatePageDataContextProvider } from './pageData';

export type ErrorHandlerProps = { context: ErrorStateDetails<TemplateCombinedState> };

type Props = {
	prefetchedData: TemplatePrefetchedContext | undefined;
	errorHandler: ComponentType<ErrorHandlerProps>;
	loadingFallback: JSX.Element;
};

export const TemplatePageContextProvider: React.FC<PropsWithChildren<Props>> = ({
	children,
	prefetchedData,
	errorHandler: ErrorHandler,
	loadingFallback,
}) => {
	const pageContextState = usePageContext(prefetchedData);

	if (isError(pageContextState)) {
		const { status, ...rest } = pageContextState;
		return <ErrorHandler context={rest} />;
	}
	if (!isLoaded(pageContextState)) return loadingFallback;

	const { pageData } = pageContextState;

	return <TemplatePageDataContextProvider pageData={pageData}>{children}</TemplatePageDataContextProvider>;
};
